// @ts-check
/// <reference path="./typedefs.js" />

import { priceFormatted } from '@/utils/formatters/formattedPrice';

/**
 * Нормализует запрос на апи Пункта выдачи заказов
 * @param {PayloadGetPvzByCode} payload
 * @return {FormattedPvzRequest}
 */
const formattedPvzRequest = (payload) => {
  const [LATITUDE = null, LONGITUDE = null] = payload.coordinates || [];

  return {
    LOCATION: payload.location || null,
    USER_ID: payload.userId || null,
    PAGE: payload.page || 1,
    LIMIT: payload.limit || 10,
    LATITUDE,
    LONGITUDE,
    DISTANCE: payload.distance || null,
    DELIVERY_METHODS: payload.deliveryMethods || [],
    BASKET_MODE: payload.isPreOrder ? 'preorder' : null,
    JUST: payload.just || null,
    CALCULATE_DELIVERY_DATE: payload.calculateDeliveryDate || 'N',
    PAY_SYSTEM_ID: payload.paymentSystemId || null,
    DELIVERY_CODE: payload.deliveryCode || null,
    PERSON_TYPE_ID: payload.personType || 1,
  };
};

/**
 * Нормализует данные пункта выдачи заказа
 * @param {PvzItem} data
 * @returns {Object}
 */
const formattedPvz = data => ({
  address: data.address,
  code: data.code,
  addressDescription: data.addressDescription,
  distance: data.distance,
  distanceFormatted: data.distanceFormat,
  coordinates: [data.latitude, data.longitude],
  schedule: data.schedule,
  deliveryCode: data.deliveryMethodCode,
  onlinePayment: data.onlinePayment,
  cashPayment: data.cashPayment,
  cardPayment: data.cardPayment,
  isPrepayment: data.isPrepayment,
  deliveryDays: data.deliveryDays,
  price: data.deliveryPrice,
  priceFormatted: priceFormatted(data.deliveryPrice),
  metroId: data.metroId,
  paymentMessage: data.paymentMessage,
  deliveryDate: data.deliveryDate?.date ?? null,
  deliveryDateFormat: data.deliveryDate?.dateFormat ?? null,
});

const processorPvz = (list) => {
  const listPvz = [];

  list.forEach((item) => {
    listPvz.push(formattedPvz(item));
  });

  return listPvz;
};

export { formattedPvzRequest, formattedPvz, processorPvz };
